<!-- 任务中心 -->
<template>
  <div class="task-center">
    <div class="task-center-con">
      <div class="banner-warp auto-img-warp">
        <img class="auto-img" src="@/assets/task/banner.png" />
      </div>
      <div class="task-center-list">
        <div
          class="task-center-item"
          v-for="(item, index) in list"
          :key="index"
          @click="toPage(item)"
        >
          <div class="box">
            <div class="box-img-warp auto-img-warp">
              <img
                class="auto-img"
                :src="require('@/assets/task/bc' + item.random + '.png')"
              />
            </div>
            <div class="box-title">{{ removeLables(item.surveyTitle) }}</div>
          </div>
        </div>
      </div>
      <el-pagination
        v-if="total > pageSize"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        layout="prev, pager, next, jumper,total"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
export default {
  name: "task-center",
  data() {
    return {
      pageNo: 1,
      pageSize: 20,
      total: 0,
      list: [],
    };
  },
  props: {},
  computed: {},
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.getTaskList();
  },
  methods: {
    removeLables(html) {
      if (!html) return "";
      return html.replace(/<\/?.+?>/g, "");
    },
    getTaskList() {
      console.log("getTaskList");
      http
        .get("/advertisingTask/page", {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.total = data.totalCount;
            this.list = data.recordList || [];
          } else {
            MSG.error(message);
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    toPage(item) {
      window.open(
        `https://wenjuan.58.com/s/?id=${item.surveyId}&hash=${item.hash}`
      );
    },
  },
};
</script>
<style lang='scss' scoped>
.task-center {
  height: calc(100vh - 78px);
  position: relative;
  color: #666;
  overflow: auto;
  .task-center-con {
    width: 1020px;
    margin: 20px auto 40px;
  }
  .banner-warp {
    padding-bottom: 17.65%;
  }
  .auto-img-warp {
    position: relative;
    width: 100%;
    height: 0;
  }
  .auto-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .task-center-item {
    width: 20%;
    padding: 5px 8px;
    .box-img-warp {
      padding-bottom: 75.263%;
    }
    cursor: pointer;
    .box {
      transition: all 0.2s;
      overflow: hidden;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 2px;
      box-shadow: 0px 6px 10px -6px rgba(0, 0, 0, 0.1);
      background-color: rgba(255, 255, 255, 1);
      height: 100%;
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 20px -12px rgba(0, 0, 0, 0.1);
      }
    }
    .box-title {
      margin: 14px 10px;
      font-weight: 400;
      line-height: 18px;
      color: #333;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      max-height: 36px;
      /*  
      position: relative;
      &::after {
        content: "...";
        position: absolute;
        bottom: 0;
        right: 0;
        padding-left: 40px;
        background: linear-gradient(to right, transparent, #fff 55%);
      } */
    }
  }
  .task-center-list {
    display: flex;
    flex-wrap: wrap;
    margin: 25px -8px 15px;
  }
  .el-pagination {
    text-align: center;
  }
}
@media screen and (min-width: 1300px) {
  .task-center-con {
    width: 66% !important;
    margin: 20px auto 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/taskCenter.vue